import { CLEAR_ACCOUNT } from './account'

export const clearStorage = ({ commit }) => {
  window.localStorage.removeItem('access-token')

  commit(CLEAR_ACCOUNT)

  location.reload(true)
}
